
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b60877585 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1636765615 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b2080184443 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1045048052 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b151039517 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.a203009519 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1083822139 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1918060464 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadres"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1725719305 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1911941928 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit is een openbaar of gedeeld apparaat."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a653935585 = messageFormatterFn((function(  ) {
  return function(d) { return "Is dit niet jouw apparaat? Door dit selectievakje aan te vinken wordt de tijd dat je hier bent aangemeld verkort."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b258039364 = messageFormatterFn((function(  ) {
  return function(d) { return "Aangemeld blijven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1860823518 = messageFormatterFn((function(  ) {
  return function(d) { return "Als je dit selectievakje aanvinkt, blijf je aangemeld bij je account op dit apparaat totdat je je afmeldt. Vink dit niet aan op gedeelde apparaten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1779965946 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord vergeten?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b769193707 = messageFormatterFn((function(  ) {
  return function(d) { return "Doorgaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1925111592 = messageFormatterFn((function(  ) {
  return function(d) { return "Annuleren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2082894559 = messageFormatterFn((function(  ) {
  return function(d) { return "Terug"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1107429725 = messageFormatterFn((function(  ) {
  return function(d) { return "Opnieuw laden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1243954792 = messageFormatterFn((function(  ) {
  return function(d) { return "Door me aan te melden, accepteer ik de <a href=" + d["1"] + " " + d["3"] + ">Voorwaarden & Bepalingen</a> van " + d["0"] + " en de <a href=" + d["2"] + " " + d["4"] + ">Privacyverklaring</a>."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1340982534 = messageFormatterFn((function(  ) {
  return function(d) { return "Door me aan te melden, accepteer ik de <a href=" + d["1"] + " " + d["5"] + ">Voorwaarden & Bepalingen</a> van " + d["0"] + ", de <a href=" + d["2"] + " " + d["6"] + ">Privacyverklaring</a> en de <a href=" + d["3"] + " " + d["7"] + ">Voorwaarden & Bepalingen van " + d["4"] + "</a>."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b693483042 = messageFormatterFn((function(  ) {
  return function(d) { return "Door me aan te melden, neem ik ook deel aan " + d["4"] + ". Ik accepteer naast de <a href=" + d["1"] + " " + d["5"] + ">Voorwaarden & Bepalingen</a> en <a href=" + d["2"] + " " + d["6"] + ">Privacyverklaring</a> van " + d["0"] + " ook de <a href=" + d["3"] + " " + d["7"] + ">Voorwaarden & Bepalingen van " + d["4"] + "</a>."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1834611123 = messageFormatterFn((function(  ) {
  return function(d) { return "Je account is tijdelijk in de wacht gezet tijdens een routineveiligheidscontrole. Je gegevens zijn veilig, maar je dient je wachtwoord opnieuw in te stellen. Wijzig je wachtwoord met de onderstaande link 'Wachtwoord vergeten?' om je aan te melden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1697084119 = messageFormatterFn((function(  ) {
  return function(d) { return "Het e-mailadres en wachtwoord komen niet overeen. Probeer het opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a256359972 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, er is bij ons iets misgegaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1774056874 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is bij ons iets misgegaan. Wacht even en probeer het opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1970728248 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je e-mailadres in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a166552153 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een geldige e-mail in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1541600385 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je wachtwoord in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b12596053 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmeldingsinfo controleren ..."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b345195078 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord verbergen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b30852939 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord weergeven"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b543399447 = messageFormatterFn((function(  ) {
  return function(d) { return "Heb je nog geen account? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Maak er eentje aan</a></span>"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1590079186 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a471903419 = messageFormatterFn((function(  ) {
  return function(d) { return "Het is niet meer mogelijk om je aan te melden via " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1247959201 = messageFormatterFn((function(  ) {
  return function(d) { return "Om toegang te krijgen tot je " + d["0"] + "-account, kan je hetzelfde e-mailadres gebruiken en je wachtwoord resetten. Dit heeft geen gevolgen voor je " + d["1"] + "-account."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1661739315 = messageFormatterFn((function(  ) {
  return function(d) { return "Reset je wachtwoord met de onderstaande knop. De volgende keer kan je je rechtstreeks aanmelden bij " + d["0"] + " met je e-mailadres en je nieuwe wachtwoord."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b179807162 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden met SSO"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1159380466 = messageFormatterFn((function(  ) {
  return function(d) { return "Log in met eenmalige aanmelding"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1658632614 = messageFormatterFn((function(  ) {
  return function(d) { return "Of gebruik je " + d["0"] + "-account"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1088226343 = messageFormatterFn((function(  ) {
  return function(d) { return "Spaar punten voor gratis reizen. Bespaar met ledenprijzen. Krijg eenvoudig toegang tot je reisplannen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a992176115 = messageFormatterFn((function(  ) {
  return function(d) { return "Spaar " + d["0"] + " Expedia Rewards-punten na deze reis."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1038505232 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden bij je " + d["0"] + "-account"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1173735246 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord vergeten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1911912809 = messageFormatterFn((function(  ) {
  return function(d) { return "Reset je wachtwoord"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1946070115 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je e-mailadres in en wij sturen je een link om je wachtwoord te resetten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1842720081 = messageFormatterFn((function(  ) {
  return function(d) { return "Resetlink sturen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a480161236 = messageFormatterFn((function(  ) {
  return function(d) { return "Controleer je inbox"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1485493628 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een e-mail met een link om je wachtwoord te resetten naar " + d["0"] + " verstuurd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1485494589 = messageFormatterFn((function(  ) {
  return function(d) { return "Het kan een paar minuten duren voor je de e-mail ontvangt. Als je het bericht over 10 minuten nog steeds niet ziet, controleer dan je map met ongewenste berichten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1763243335 = messageFormatterFn((function(  ) {
  return function(d) { return "Link opnieuw versturen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1521544033 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een nieuwe link verstuurd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a153829518 = messageFormatterFn((function(  ) {
  return function(d) { return "Account verifiëren ..."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b701347826 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord resetten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1656766633 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom terug"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b913685411 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een uniek wachtwoord aan om door te gaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1796537736 = messageFormatterFn((function(  ) {
  return function(d) { return "Gelukt!"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a723906885 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik je nieuwe wachtwoord om verder te gaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b85153952 = messageFormatterFn((function(  ) {
  return function(d) { return "Stel je wachtwoord opnieuw in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b999350947 = messageFormatterFn((function(  ) {
  return function(d) { return "Helaas is dit verzoek verlopen. Als je je wachtwoord nog steeds wilt wijzigen, klik dan hieronder om opnieuw een bericht te versturen om je wachtwoord in te stellen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1793725869 = messageFormatterFn((function(  ) {
  return function(d) { return "Link opnieuw versturen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b792664104 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord opslaan ..."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1695675084 = messageFormatterFn((function(  ) {
  return function(d) { return "Account aanmaken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1459951032 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een account aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b936095949 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadres"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1381771947 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je e-mailadres in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1183790724 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een geldige e-mail in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1000018222 = messageFormatterFn((function(  ) {
  return function(d) { return "Voornaam"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b138260918 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je voornaam in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1557950156 = messageFormatterFn((function(  ) {
  return function(d) { return "Achternaam"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1323745196 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je achternaam in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1648085709 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een naam in die alleen uit letters bestaat."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1886634682 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b473362738 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je wachtwoord in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2087105117 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer een geldig wachtwoord in."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a70488707 = messageFormatterFn((function(  ) {
  return function(d) { return "Bestaat uit 9-64 tekens"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a70489668 = messageFormatterFn((function(  ) {
  return function(d) { return "Is een combinatie van letters en nummers"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a70490629 = messageFormatterFn((function(  ) {
  return function(d) { return "Een speciaal teken ~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a70491590 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord mag geen spaties bevatten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1284012781 = messageFormatterFn((function(  ) {
  return function(d) { return "Je wachtwoord dient 8 tot 64 tekens te bevatten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b327074688 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord mag niet overeenkomen met je e-mailadres."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1066018109 = messageFormatterFn((function(  ) {
  return function(d) { return "Het wachtwoord mag geen spaties bevatten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b362520779 = messageFormatterFn((function(  ) {
  return function(d) { return "Door een account aan te maken, accepteer ik de <a href=" + d["1"] + " " + d["3"] + ">Voorwaarden & Bepalingen van " + d["0"] + "</a> en de <a href=" + d["2"] + " " + d["4"] + ">Privacyverklaring</a>."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1174507341 = messageFormatterFn((function(  ) {
  return function(d) { return "Door een account aan te maken, accepteer ik de <a href=" + d["1"] + " " + d["5"] + ">Voorwaarden & Bepalingen</a> van " + d["0"] + ", de <a href=" + d["2"] + " " + d["6"] + ">Privacyverklaring</a> en de <a href=" + d["3"] + " " + d["7"] + ">Voorwaarden & Bepalingen van " + d["4"] + "</a>."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a958570030 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik wil e-mails met reisaanbiedingen, speciale deals en andere informatie van " + d["0"] + " ontvangen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1998323967 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik wil e-mails met reisaanbiedingen, speciale deals en andere informatie van " + d["0"] + " ontvangen. Je kan je op elk moment voor deze e-mails afmelden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1074962161 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik wil e-mails met vakantie-ideeën, speciale deals en andere informatie van " + d["0"] + " ontvangen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1407488798 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik wil e-mails met vakantie-ideeën, speciale deals en andere informatie van " + d["0"] + " ontvangen. Je kan je op elk moment voor deze e-mails afmelden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b86580398 = messageFormatterFn((function(  ) {
  return function(d) { return "Doorgaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1836623487 = messageFormatterFn((function(  ) {
  return function(d) { return "Heb je al een account? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Meld je aan</a></span>"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a661074332 = messageFormatterFn((function(  ) {
  return function(d) { return "Welkom, " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b982660822 = messageFormatterFn((function(  ) {
  return function(d) { return "Met je nieuwe " + d["0"] + "-account is de wereld binnen handbereik."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b548860045 = messageFormatterFn((function(  ) {
  return function(d) { return "Doorgaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b23799362 = messageFormatterFn((function(  ) {
  return function(d) { return "Je wachtwoord is niet sterk genoeg om door te gaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a511480323 = messageFormatterFn((function(  ) {
  return function(d) { return "Het dient uit minstens 8 tekens te bestaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b220632153 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoordsterkte"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b519812677 = messageFormatterFn((function(  ) {
  return function(d) { return "Zwak"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1215234842 = messageFormatterFn((function(  ) {
  return function(d) { return "Sterk"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a296016496 = messageFormatterFn((function(  ) {
  return function(d) { return "Zeer sterk"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b469073675 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermijd voorspelbare lettervervangingen zoals ‘@’ voor ‘a’."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1176080797 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermijd omgekeerde spelling van veelgebruikte woorden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a113120187 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik hoofdletters, maar niet voor alle letters."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b58505764 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik hoofdletters voor meer dan alleen de eerste letter."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1618450560 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermijd datums en jaartallen die voor jou een speciale betekenis hebben."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1755613514 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermijd recente jaartallen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1121451631 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermijd jaartallen die voor jou een speciale betekenis hebben."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1578468036 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermijd veelvoorkomende tekenreeksen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a696939670 = messageFormatterFn((function(  ) {
  return function(d) { return "Vermijd herhalingen van woorden en tekens."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1271554938 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik langere toetsenbordpatronen en verander de typrichting meerdere keren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b703506017 = messageFormatterFn((function(  ) {
  return function(d) { return "Voeg meer woorden toe die minder vaak voorkomen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b148876341 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik meerdere woorden, maar vermijd veelvoorkomende woordgroepen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b961825554 = messageFormatterFn((function(  ) {
  return function(d) { return "Je kan sterke wachtwoorden maken zonder symbolen, cijfers of hoofdletters te gebruiken."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1340411637 = messageFormatterFn((function(  ) {
  return function(d) { return "Er bestaat al een account op " + d["0"] + " met dit e-mailadres."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1257841721 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben je een e-mail met een link gestuurd om het aanmaken van je account te voltooien."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1003372648 = messageFormatterFn((function(  ) {
  return function(d) { return "Account aanmaken ..."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1906628692 = messageFormatterFn((function(  ) {
  return function(d) { return "De voornaam dient uit minstens 2 letters te bestaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1565751322 = messageFormatterFn((function(  ) {
  return function(d) { return "De achternaam dient uit minstens 2 letters te bestaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1140288766 = messageFormatterFn((function(  ) {
  return function(d) { return "De voornaam mag uit max. 100 tekens bestaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1481166136 = messageFormatterFn((function(  ) {
  return function(d) { return "De achternaam mag uit max. 100 tekens bestaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b179134083 = messageFormatterFn((function(  ) {
  return function(d) { return "De voornaam mag geen speciale tekens bevatten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1344772157 = messageFormatterFn((function(  ) {
  return function(d) { return "De achternaam mag geen speciale tekens bevatten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a751243803 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik stem in met al het onderstaande"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b676169497 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik bevestig dat ik 18 jaar of ouder ben en dat ik de <a href=" + d["0"] + " " + d["1"] + ">Gebruiksvoorwaarden</a> en de <a href=" + d["2"] + " " + d["3"] + ">Voorwaarden & Bepalingen van " + d["4"] + "</a> heb gelezen en ermee instem (verplicht)"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1254256453 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik geef toestemming voor het sparen en gebruiken van mijn persoonlijke gegevens zoals beschreven in het <a href=" + d["0"] + " " + d["1"] + ">Privacybeleid</a> (verplicht)"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a762118450 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik geef toestemming voor het verstrekken van mijn persoonlijke gegevens aan derde partijen, in Korea of in het buitenland, zoals beschreven in het <a href=" + d["0"] + " " + d["1"] + ">Privacybeleid</a> (verplicht)"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b664539089 = messageFormatterFn((function(  ) {
  return function(d) { return "Accepteer de voorwaarden om door te gaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a93185003 = messageFormatterFn((function(  ) {
  return function(d) { return "Accepteer de voorwaarden om door te gaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1147491929 = messageFormatterFn((function(  ) {
  return function(d) { return "Vink het vakje aan om door te gaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a696600608 = messageFormatterFn((function(  ) {
  return function(d) { return "Of maak een account aan met " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a693565982 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik geen spaties, je naam, e-mail of wachtwoorden die je eerder al hebt gebruikt."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b439657218 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is een interne fout opgetreden. Wacht een paar minuten en daarna probeer het opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a594230628 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifieer je mobiele telefoonnummer"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a102577749 = messageFormatterFn((function(  ) {
  return function(d) { return "We verzenden een eenmalige verificatiecode naar je mobiele telefoonnummer om ervoor te zorgen dat je account veilig blijft."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1482678450 = messageFormatterFn((function(  ) {
  return function(d) { return "Verzenden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1714440405 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + ". Alle rechten voorbehouden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a235058211 = messageFormatterFn((function(  ) {
  return function(d) { return "Voorwaarden & Bepalingen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1075339868 = messageFormatterFn((function(  ) {
  return function(d) { return "Privacybeleid"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b744894811 = messageFormatterFn((function(  ) {
  return function(d) { return "Stuur me een bericht"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2022981488 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je verificatiecode in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a507201026 = messageFormatterFn((function(  ) {
  return function(d) { return "Verificatiecode"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1051758645 = messageFormatterFn((function(  ) {
  return function(d) { return "Code opnieuw verzenden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1705876682 = messageFormatterFn((function(  ) {
  return function(d) { return "Mobiele telefoonnummer wijzigen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b196158402 = messageFormatterFn((function(  ) {
  return function(d) { return "De verificatiecode is opnieuw verzonden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b837163127 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de 6-cijferige verificatiecode in die we zonet naar " + d["0"] + " verzonden hebben"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a648152932 = messageFormatterFn((function(  ) {
  return function(d) { return "Verificatiecode wordt gecontroleerd"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a422020643 = messageFormatterFn((function(  ) {
  return function(d) { return "Deze code klopt niet. Verstuur de code opnieuw om het nogmaals te proberen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b792035453 = messageFormatterFn((function(  ) {
  return function(d) { return "of ga verder met"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1548247661 = messageFormatterFn((function(  ) {
  return function(d) { return "Bespaar gemiddeld " + d["0"] + "% op duizenden hotels met een kosteloos lidmaatschap."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1020216609 = messageFormatterFn((function(  ) {
  return function(d) { return "of"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1509023839 = messageFormatterFn((function(  ) {
  return function(d) { return "Andere aanmeldopties"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1509383253 = messageFormatterFn((function(  ) {
  return function(d) { return "Je kan ook een account aanmaken via"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a354659541 = messageFormatterFn((function(  ) {
  return function(d) { return "Account aanmaken via Google"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1892113868 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden is mislukt. Probeer het opnieuw of maak een account aan voor deze site om verder te gaan."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1870947118 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden via telefoonnummer is niet beschikbaar. Zorg ervoor dat je socialmedia-account is ingesteld op het delen van je e-mail."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1765492186 = messageFormatterFn((function(  ) {
  return function(d) { return "Bespaar " + d["0"] + "% of meer op duizenden hotels met een kosteloos lidmaatschap."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1979086581 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden via Google"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a205411360 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden via NAVER"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1304077718 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt het maximum aanmeldpogingen overschreden. Probeer het later opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b429828099 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan met biometrische gegevens"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a999220227 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik biometrische gegevens om je account te ontgrendelen zodat je je wachtwoord niet hoeft in te typen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b294556240 = messageFormatterFn((function(  ) {
  return function(d) { return "Aan de slag"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1412679808 = messageFormatterFn((function(  ) {
  return function(d) { return "Herinner me er later aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1357176010 = messageFormatterFn((function(  ) {
  return function(d) { return "Gelukt!"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1255384688 = messageFormatterFn((function(  ) {
  return function(d) { return "Biometrisch aanmelden is ingeschakeld."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b973857896 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden met biometrische gegevens"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1802094109 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord gebruiken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b422982824 = messageFormatterFn((function(  ) {
  return function(d) { return "Biometrische gegevens gebruiken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a443720175 = messageFormatterFn((function(  ) {
  return function(d) { return "Werk je wachtwoord bij om door te gaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a676665709 = messageFormatterFn((function(  ) {
  return function(d) { return "Om toegang te krijgen tot je account, dien je je wachtwoord te resetten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1953753469 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord opnieuw instellen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b336911261 = messageFormatterFn((function(  ) {
  return function(d) { return "Geniet van ledenvoordelen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a489873481 = messageFormatterFn((function(  ) {
  return function(d) { return "Begin je volgende avontuur met een cadeau. We geven je voor $" + d["0"] + " aan punten!"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1570557433 = messageFormatterFn((function(  ) {
  return function(d) { return "Je vindt ze in je account en je kan ze bij je eerste boeking gebruiken door bij het afrekenen de optie om punten toe te passen aan te klikken."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b229858571 = messageFormatterFn((function(  ) {
  return function(d) { return "Je bent nu lid van Expedia."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1887552731 = messageFormatterFn((function(  ) {
  return function(d) { return "Bespaar gelijk met ledenprijzen en spaar punten wanneer je boekt."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1951563984 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan of maak een account aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a618792970 = messageFormatterFn((function(  ) {
  return function(d) { return "Bespaar gemiddeld " + d["0"] + "% op duizenden hotels met een kosteloos lidmaatschap."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1438163592 = messageFormatterFn((function(  ) {
  return function(d) { return "Als je doorgaat, bevestig je dat je onze <a href=" + d["1"] + " " + d["3"] + ">Voorwaarden & Bepalingen</a> en onze <a href=" + d["2"] + " " + d["4"] + ">Privacyverklaring</a> hebt gelezen en ermee akkoord gaat."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a276239850 = messageFormatterFn((function(  ) {
  return function(d) { return "Als je doorgaat, bevestig je dat je onze <a href=" + d["1"] + " " + d["5"] + ">Voorwaarden & Bepalingen</a>, onze <a href=" + d["2"] + " " + d["6"] + ">Privacyverklaring</a> en de <a href=" + d["3"] + " " + d["7"] + ">Voorwaarden & Bepalingen van " + d["4"] + "</a> hebt gelezen en ermee akkoord gaat."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1256727803 = messageFormatterFn((function(  ) {
  return function(d) { return "Als je doorgaat, bevestig je dat je onze <a href=" + d["1"] + " " + d["4"] + ">Voorwaarden & Bepalingen</a>, onze <a href=" + d["2"] + " " + d["5"] + ">Privacyverklaring</a> en de <a href=" + d["3"] + " " + d["6"] + ">Voorwaarden & Bepalingen van het One Key-loyaliteitsprogramma</a> hebt gelezen en ermee akkoord gaat."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b521090049 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b581110407 = messageFormatterFn((function(  ) {
  return function(d) { return "Geef een geldig e-mailadres op"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2101786172 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b575688311 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1284194957 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1122535034 = messageFormatterFn((function(  ) {
  return function(d) { return "Dit is alleen voor persoonlijke apparaten. Vink dit niet aan op gedeelde apparaten om je account veilig te houden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1498630281 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt je te vaak geprobeerd aan te melden. Wacht " + d["0"] + " minuten voordat je het opnieuw probeert."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1347035845 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt je te vaak geprobeerd aan te melden. Wacht " + d["0"] + " minuut voordat je het opnieuw probeert."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1342140511 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt je te vaak geprobeerd aan te melden. Wacht " + d["0"] + " minuten voordat je het opnieuw probeert."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1355598355 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt je te vaak geprobeerd aan te melden. Wacht " + d["0"] + " minuten voordat je het opnieuw probeert."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1122647680 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt je te vaak geprobeerd aan te melden. Wacht " + d["0"] + " minuten voordat je het opnieuw probeert."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1539728155 = messageFormatterFn((function(  ) {
  return function(d) { return "Je hebt je te vaak geprobeerd aan te melden. Wacht " + d["0"] + " minuten voordat je het opnieuw probeert."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1943124372 = messageFormatterFn((function(  ) {
  return function(d) { return "Krijg toegang tot een wereld aan voordelen met één account voor Expedia, Hotels.com en Vrbo."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a446178596 = messageFormatterFn((function(  ) {
  return function(d) { return "Krijg toegang tot een wereld aan reizen met één account voor Expedia, Hotels.com en Vrbo."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2077309397 = messageFormatterFn((function(  ) {
  return function(d) { return "Blader door accommodaties en sla ze op, maak plannen met je groep en bekijk je boekingsdetails."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1881113686 = messageFormatterFn((function(  ) {
  return function(d) { return "Je account is tijdelijk stopgezet tijdens een routineveiligheidscontrole. Je gegevens zijn veilig, maar je dient je wachtwoord opnieuw in te stellen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a51275398 = messageFormatterFn((function(  ) {
  return function(d) { return "Meld je aan en boek je verblijf om OneKeyCash te sparen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1677183986 = messageFormatterFn((function(  ) {
  return function(d) { return "Laten we bevestigen dat jij het bent"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a914859020 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de beveiligingscode in die we naar je e-mailadres hebben verzonden. Kijk in je spammap als je geen e-mail hebt ontvangen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a95493600 = messageFormatterFn((function(  ) {
  return function(d) { return "Je e-mailadres bevestigen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b165048070 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de beveiligingscode in die we naar " + d["0"] + " hebben verzonden om verder te gaan. Kijk in je spammap als je geen e-mail hebt ontvangen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b950736308 = messageFormatterFn((function(  ) {
  return function(d) { return "6-cijferige code"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1919849932 = messageFormatterFn((function(  ) {
  return function(d) { return "Code opnieuw verzenden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b394531037 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a886584981 = messageFormatterFn((function(  ) {
  return function(d) { return "Code opnieuw verzenden over " + d["0"] + "s"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a801436069 = messageFormatterFn((function(  ) {
  return function(d) { return "Geen e-mail ontvangen?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a315108995 = messageFormatterFn((function(  ) {
  return function(d) { return "Je kan over " + d["0"] + " sec. een nieuwe code aanvragen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b404047482 = messageFormatterFn((function(  ) {
  return function(d) { return "Een nieuwe beveiligingscode aanvragen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2001405712 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben een nieuwe 6-cijferige code naar je inbox gestuurd."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a223311835 = messageFormatterFn((function(  ) {
  return function(d) { return "In plaats daarvan wachtwoord invoeren"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a370824390 = messageFormatterFn((function(  ) {
  return function(d) { return "Ongeldige code, probeer het opnieuw"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b737674252 = messageFormatterFn((function(  ) {
  return function(d) { return "Code is verlopen, verzend opnieuw"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1887443433 = messageFormatterFn((function(  ) {
  return function(d) { return "Kijk in je spammap als je geen e-mail hebt ontvangen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1288460144 = messageFormatterFn((function(  ) {
  return function(d) { return "We hebben onze ervaring bijgewerkt en vragen je daarom om je e-mailadres te bevestigen. Voer de beveiligingscode in die we naar je inbox hebben verzonden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1832002449 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is iets misgegaan bij ons. Probeer het opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a2076537400 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer de beveiligingscode in die we naar je e-mailadres hebben verzonden om je aanmeldingsmethode bij te werken."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1886330802 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je wachtwoord in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1478682489 = messageFormatterFn((function(  ) {
  return function(d) { return "Beveiligingscode verzenden via e-mail"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b523836679 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mailadres en wachtwoord komen niet overeen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1717481154 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een wachtwoord aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1135474644 = messageFormatterFn((function(  ) {
  return function(d) { return "Maak een wachtwoord aan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1509231826 = messageFormatterFn((function(  ) {
  return function(d) { return "Je kan hetzelfde e-mailadres en wachtwoord gebruiken om in te loggen bij Expedia, Hotels.com en Vrbo."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1624255694 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord aanmaken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1435022251 = messageFormatterFn((function(  ) {
  return function(d) { return "Stel een wachtwoord in om naast andere veilige aanmeldmethodes te gebruiken."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b166584096 = messageFormatterFn((function(  ) {
  return function(d) { return "Stel een nieuw wachtwoord in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a754019018 = messageFormatterFn((function(  ) {
  return function(d) { return "Stel een nieuw wachtwoord in"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1444928560 = messageFormatterFn((function(  ) {
  return function(d) { return "Je kan nu met één account inloggen bij Expedia, Hotels.com en Vrbo. Maak een nieuw veilig wachtwoord aan voor je gecombineerde account."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1521072304 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord aanmaken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1479660824 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord wijzigen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1258312344 = messageFormatterFn((function(  ) {
  return function(d) { return "Gebruik een uniek en sterk wachtwoord."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a91898760 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord bijwerken"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1571611403 = messageFormatterFn((function(  ) {
  return function(d) { return "We konden je wachtwoord niet bijwerken. Probeer het opnieuw."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1971190445 = messageFormatterFn((function(  ) {
  return function(d) { return "Wachtwoord vergeten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b393244505 = messageFormatterFn((function(  ) {
  return function(d) { return "Voer je e-mailadres in, dan sturen we je een beveiligingscode waarmee je je kan aanmelden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1707153177 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail verzenden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a67064293 = messageFormatterFn((function(  ) {
  return function(d) { return "Contact opnemen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1637971542 = messageFormatterFn((function(  ) {
  return function(d) { return "Gegevens verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1000618913 = messageFormatterFn((function(  ) {
  return function(d) { return "Sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1208064253 = messageFormatterFn((function(  ) {
  return function(d) { return "Even geduld. We controleren je account."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1440932828 = messageFormatterFn((function(  ) {
  return function(d) { return "Account verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1004430528 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik snap het"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1670176764 = messageFormatterFn((function(  ) {
  return function(d) { return "Je kan je account pas verwijderen nadat je reis is voltooid."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1286920795 = messageFormatterFn((function(  ) {
  return function(d) { return "In het geval van last minute wijzigingen heb je het account namelijk nodig om je boeking te bekijken en hulp te vragen aan de klantendienst."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b153740914 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwijder eerst je Vrbo-eigenaarsaccount"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1656039337 = messageFormatterFn((function(  ) {
  return function(d) { return "Ga naar ons hulpcentrum op de website of de app om rechtstreeks contact op te nemen met de klantendienst en het proces op gang te brengen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b468912807 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer het opnieuw nadat je je reis hebt afgerond."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1050876810 = messageFormatterFn((function(  ) {
  return function(d) { return "Vertel ons waarom je je account verwijdert"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b160117799 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik krijg te veel e-mails of notificaties"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b727579793 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik heb een ander " + d["0"] + "-account"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1255239914 = messageFormatterFn((function(  ) {
  return function(d) { return "Mijn reis is voorbij, dus ik heb dit account niet meer nodig"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b630933328 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik had een negatieve ervaring met het boeken bij " + d["0"]; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1628085777 = messageFormatterFn((function(  ) {
  return function(d) { return "Overig"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1448932590 = messageFormatterFn((function(  ) {
  return function(d) { return "Overslaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1209486859 = messageFormatterFn((function(  ) {
  return function(d) { return "Indienen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b383912315 = messageFormatterFn((function(  ) {
  return function(d) { return "We zien je niet graag gaan! Misschien wil je eerst dit nog weten:"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1576326184 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + "Expedia Rewards-punten ter waarde van " + d["1"] + ", tegoeden ter waarde van " + d["2"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1077830647 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + "Expedia Rewards-punten ter waarde van " + d["1"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1964883403 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je reisprikborden, tegoeden en voorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1978571713 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: je verliest " + d["0"] + " bonusnachten ter waarde van " + d["1"] + " en " + d["2"] + " stempels met een gemiddelde waarde van " + d["3"] + "."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b348287342 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je tegoeden, coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1952795078 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + " CheapCash ter waarde van " + d["1"] + ", tegoeden ter waarde van " + d["2"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1735924407 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + " CheapCash ter waarde van " + d["1"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b850499662 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + " Orbucks ter waarde van " + d["1"] + ", tegoeden ter waarde van " + d["2"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1769910721 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + " Orbucks ter waarde van " + d["1"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1391412136 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + " MrJet Rewards ter waarde van " + d["1"] + ", tegoeden ter waarde van " + d["2"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1441891191 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + "MrJet Rewards ter waarde van " + d["1"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1470348378 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + " BONUS+ ter waarde van " + d["1"] + ", tegoeden ter waarde van " + d["2"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a199491735 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je " + d["0"] + " BONUS+ ter waarde van " + d["1"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b776496412 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1264549639 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je tegoeden ter waarde van " + d["0"] + ", coupons, opgeslagen reisitems en accountvoorkeuren."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1490046307 = messageFormatterFn((function(  ) {
  return function(d) { return "Het is mogelijk dat we bepaalde informatie op beveiligde manier bewaren, zoals rapporten van je transacties, om te voldoen aan wettelijke verplichtingen of voor het geval dat we een rechtsvordering moeten vaststellen, uitoefenen of onderbouwen. Die informatie wordt veilig bewaard en wordt verwijderd, geanonimiseerd of permanent gecodeerd van zodra deze niet langer nodig is."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b929314577 = messageFormatterFn((function(  ) {
  return function(d) { return "Account permanent verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1130126177 = messageFormatterFn((function(  ) {
  return function(d) { return "Account niet verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1556455337 = messageFormatterFn((function(  ) {
  return function(d) { return "We hopen je weer terug te zien"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a625188152 = messageFormatterFn((function(  ) {
  return function(d) { return "Het kan enkele weken duren voor je verwijderingsverzoek is verwerkt. Je kan dus nog steeds berichten van ons ontvangen terwijl ons systeem bijgewerkt wordt."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1374848942 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer het opnieuw"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1726792049 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is een systeemfout opgetreden. Verzend je verwijderingsverzoek opnieuw of probeer het over een paar minuten nog eens."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b137032937 = messageFormatterFn((function(  ) {
  return function(d) { return "Sluiten"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1467663824 = messageFormatterFn((function(  ) {
  return function(d) { return "Welke naam gebruik je op je reiziger-id?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1398326624 = messageFormatterFn((function(  ) {
  return function(d) { return "Zorg ervoor dat je accountnaam overeenkomt met het identiteitsbewijs dat je gebruikt wanneer je reist, zoals je paspoort. We slaan deze informatie op voor bij je volgende boeking."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a959536654 = messageFormatterFn((function(  ) {
  return function(d) { return "Ontvang e-mails van " + d["0"] + " met deals, promoties en andere informatie."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1424749791 = messageFormatterFn((function(  ) {
  return function(d) { return "Ontvang e-mails van " + d["0"] + " met deals, promoties en andere informatie. Je kan je op elk moment afmelden voor marketingberichten."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b587287844 = messageFormatterFn((function(  ) {
  return function(d) { return "Accountinfo"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a385016626 = messageFormatterFn((function(  ) {
  return function(d) { return "Ontvang e-mails over deals, promoties en andere info van " + d["0"] + ". Je kan je op elk moment afmelden."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1189311118 = messageFormatterFn((function(  ) {
  return function(d) { return "Blijf op de hoogte"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1519247384 = messageFormatterFn((function(  ) {
  return function(d) { return "Toestemming marketing"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1953058471 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1704588059 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1932599635 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a264147387 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b319925785 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a466703714 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1930691798 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a761783063 = messageFormatterFn((function(  ) {
  return function(d) { return "Je moet helaas wachten tot na je reis"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a763900313 = messageFormatterFn((function(  ) {
  return function(d) { return "Je moet helaas wachten tot na je aanstaande reizen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b385658687 = messageFormatterFn((function(  ) {
  return function(d) { return "Met je account kan je de boekingsdetails bekijken en indien nodig ondersteuning vragen. Probeer het opnieuw nadat je je reis hebt afgerond."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1649018563 = messageFormatterFn((function(  ) {
  return function(d) { return "Met je account kan je de boekingsdetails bekijken en indien nodig ondersteuning vragen. Probeer het opnieuw nadat je je reizen hebt afgerond."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b529431876 = messageFormatterFn((function(  ) {
  return function(d) { return "Je kan je account op dit moment niet verwijderen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1813698074 = messageFormatterFn((function(  ) {
  return function(d) { return "Je gebruikt dit account ook als eigenaar van accommodaties op Vrbo.  Meld je aan in de Vrbo-app voor eigenaren of op de website en verwijder je actieve advertenties. Pas dan kan je je account verwijderen."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a326437385 = messageFormatterFn((function(  ) {
  return function(d) { return "Kan je ons vertellen waarom je vertrekt?"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1306217026 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik heb een account met een andere e-mail."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1334359357 = messageFormatterFn((function(  ) {
  return function(d) { return "Ik had een negatieve boekingservaring."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b266464040 = messageFormatterFn((function(  ) {
  return function(d) { return "We vinden het jammer dat je vertrekt. Denk eraan: je gaat je account definitief verwijderen en dat heeft gevolgen voor je gegevens bij Expedia, Hotels.com en Vrbo. Misschien wil je eerst dit nog weten:"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2106653789 = messageFormatterFn((function(  ) {
  return function(d) { return "We vinden het jammer dat je vertrekt. Denk eraan: je gaat je account definitief verwijderen en dat heeft gevolgen voor je gegevens bij Expedia, Wotif, Hotels.com en Vrbo. Misschien wil je eerst dit nog weten:"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1059488540 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je accountgeschiedenis, voorkeuren en opgeslagen items bij Expedia, Hotels.com en Vrbo."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1647889745 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je accountgeschiedenis, voorkeuren en opgeslagen items bij Expedia, Wotif, Hotels.com en Vrbo."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a201405080 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je OneKeyCash, met inbegrip van OneKeyCash in behandeling, je One Key-niveau en alle extra's."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a742498190 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed je OneKeyCash in behandeling, je One Key-niveau en alle extra's."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1723564387 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed " + d["0"] + " aan OneKeyCash, je OneKeyCash in behandeling, je One Key-niveau en alle extra's."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b2118788519 = messageFormatterFn((function(  ) {
  return function(d) { return "Als je een Hotels.com Rewards-creditcard hebt, spaar je daar niet langer punten mee."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1290583178 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed al je Expedia Rewards-punten, Hotels.com Rewards-stempels en bonusnachten, of ze nu bevestigd zijn of in behandeling, en je voordelenniveau."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1295497876 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed al je Expedia Rewards-punten, Hotels.com Rewards-stempels en bonusnachten in behandeling, en je voordelenniveau."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b956328526 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed al je coupons en tegoeden voor Expedia, Hotels.com en Vrbo."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a373225725 = messageFormatterFn((function(  ) {
  return function(d) { return "Je verliest voorgoed al je coupons en tegoeden voor Expedia, Wotif, Hotels.com en Vrbo."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a65710411 = messageFormatterFn((function(  ) {
  return function(d) { return "Het kan enkele weken duren voor je verwijderingsverzoek voor Expedia, Hotels.com en Vrbo is verwerkt. Je kan dus nog steeds berichten van ons ontvangen terwijl ons systeem bijgewerkt wordt."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1793668566 = messageFormatterFn((function(  ) {
  return function(d) { return "Het kan enkele weken duren voor je verwijderingsverzoek voor Expedia, Wotif, Hotels.com en Vrbo is verwerkt. Je kan dus nog steeds berichten van ons ontvangen terwijl ons systeem bijgewerkt wordt."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1638436992 = messageFormatterFn((function(  ) {
  return function(d) { return "Je One Key Card wordt opgezegd als je je account verwijderd en je spaart geen OneKeyCash meer met je aankopen. Wells Fargo neemt contact met je op ter bevestiging van het opzeggen van je kaart."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b832615510 = messageFormatterFn((function(  ) {
  return function(d) { return "Je One Key+ Card wordt opgezegd als je je account verwijderd en je spaart geen OneKeyCash meer met je aankopen. Wells Fargo neemt contact met je op ter bevestiging van het opzeggen van je kaart."; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a1117657025 = messageFormatterFn((function(  ) {
  return function(d) { return "Log in of maak een account om OneKeyCash te sparen met je reis"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b1669646023 = messageFormatterFn((function(  ) {
  return function(d) { return "Log in of maak een account om beloningen te sparen met dit verblijf"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b226959488 = messageFormatterFn((function(  ) {
  return function(d) { return "Verder gaan als gast"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b771027186 = messageFormatterFn((function(  ) {
  return function(d) { return "Aanmelden bij " + d["0"] + "-account: mobiel nummer toevoegen"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.a592739938 = messageFormatterFn((function(  ) {
  return function(d) { return "Er is iets misgegaan"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b918094172 = messageFormatterFn((function(  ) {
  return function(d) { return "Probeer je opnieuw aan te melden"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b555161829 = messageFormatterFn((function(  ) {
  return function(d) { return "Oké"; }
})(), Globalize("nl-BE").pluralGenerator({}));
Globalize.b282768579 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1397314947 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b521137648 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1643591606 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1343173923 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b2067434478 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a454548093 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1289032899 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b759538627 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b762709040 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b2061593891 = dateToPartsFormatterFn({"2":Globalize("nl-BE").numberFormatter({"raw":"00"}),"4":Globalize("nl-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b500296958 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"Z","mon":"M","tue":"D","wed":"W","thu":"D","fri":"V","sat":"Z"}}}});
Globalize.a1646398525 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"zondag","mon":"maandag","tue":"dinsdag","wed":"woensdag","thu":"donderdag","fri":"vrijdag","sat":"zaterdag"}}}});
Globalize.a393153085 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b2067027005 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1572305520 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"}),"2":Globalize("nl-BE").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a951232081 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b595937704 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.a762821469 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1222379485 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"januari","2":"februari","3":"maart","4":"april","5":"mei","6":"juni","7":"juli","8":"augustus","9":"september","10":"oktober","11":"november","12":"december"}}}});
Globalize.b1221694292 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b35181039 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"EEEE d MMM","timeSeparator":":","days":{"E":{"4":{"sun":"zondag","mon":"maandag","tue":"dinsdag","wed":"woensdag","thu":"donderdag","fri":"vrijdag","sat":"zaterdag"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.b603325872 = dateToPartsFormatterFn({"1":Globalize("nl-BE").numberFormatter({"raw":"0"})}, {"pattern":"E d MMM","timeSeparator":":","days":{"E":{"1":{"sun":"zo","mon":"ma","tue":"di","wed":"wo","thu":"do","fri":"vr","sat":"za"}}},"months":{"M":{"3":{"1":"jan.","2":"feb.","3":"mrt.","4":"apr.","5":"mei","6":"jun.","7":"jul.","8":"aug.","9":"sep.","10":"okt.","11":"nov.","12":"dec."}}}});
Globalize.a95945172 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1018601196 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1293779559 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a171325601 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b964460172 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b252517271 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a833261844 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b910319148 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b380824876 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1052208167 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b1682880140 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b651470325 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a810237972 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b443007468 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b1483743412 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"d"}));
Globalize.a1180898439 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1379090650 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b217223953 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b381954138 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b843665734 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b842980541 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b652911590 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b224612121 = dateFormatterFn(Globalize("nl-BE").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1710006915 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a595460547 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a504398550 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b618055408 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a649601571 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b1041898280 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b1847643709 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a703742595 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a1233236867 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a262827158 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b68818397 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1154664444 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^Z/],["mon",/^M/],["tue",/^D/],["wed",/^W/],["thu",/^D/],["fri",/^V/],["sat",/^Z/]]});
Globalize.b101330941 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^donderdag/],["wed",/^woensdag/],["sat",/^zaterdag/],["mon",/^maandag/],["tue",/^dinsdag/],["fri",/^vrijdag/],["sun",/^zondag/]]});
Globalize.b1354576381 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.a1253436861 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1336501430 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1616884149 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
Globalize.a1396837790 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.b1885647657 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.a770396009 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^september/],["2",/^februari/],["8",/^augustus/],["11",/^november/],["12",/^december/],["1",/^januari/],["10",/^oktober/],["3",/^maart/],["4",/^april/],["6",/^juni/],["7",/^juli/],["5",/^mei/]]});
Globalize.a771081202 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
Globalize.a1701595403 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE d MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^donderdag/],["wed",/^woensdag/],["sat",/^zaterdag/],["mon",/^maandag/],["tue",/^dinsdag/],["fri",/^vrijdag/],["sun",/^zondag/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
Globalize.a1389449622 = dateParserFn(Globalize("nl-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E d MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^zo/],["mon",/^ma/],["tue",/^di/],["wed",/^wo/],["thu",/^do/],["fri",/^vr/],["sat",/^za/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^feb\./],["3",/^mrt\./],["4",/^apr\./],["6",/^jun\./],["7",/^jul\./],["8",/^aug\./],["9",/^sep\./],["10",/^okt\./],["11",/^nov\./],["12",/^dec\./],["5",/^mei/]]});
module.exports = Globalize;
